module.exports = __webpack_public_path__ + "static/media/botonvolver.0625c342.svg";